export interface NormalizedError {
  status: number;
  message: string;
}

export function mapHttpError(err: any): NormalizedError {
  if (process.env.NODE_ENV !== "production") {
    console.error("Raw error:", err);
  }

  if (err.response) {
    switch (err.response.status) {
      case 400:
        return {
          status: 400,
          message:
            "We couldn’t process your request. Please check and try again.",
        };
      case 401:
        return {
          status: 401,
          message: "Your session has expired. Please log in again.",
        };
      case 403:
        return {
          status: 403,
          message: "You don’t have permission to do this action.",
        };
      case 404:
        return {
          status: 404,
          message: "The page or resource you’re looking for was not found.",
        };
      case 500:
        return {
          status: 500,
          message: "Something went wrong. Please try again later.",
        };
      case 503:
        return {
          status: 503,
          message:
            "The service is temporarily unavailable. Please try again soon.",
        };
      default:
        return {
          status: err.response.status,
          message: "We ran into an unexpected issue. Please try again later.",
        };
    }
  }

  // 🔹 Network error (browser-only)
  if (err.message === "Network Error") {
    return {
      status: 503,
      message:
        "We can’t reach the server right now. Please check your internet connection.",
    };
  }

  // 🔹 Timeout (Axios-specific)
  if (err.code === "ECONNABORTED") {
    return {
      status: 504,
      message: "The request took too long to respond. Please try again.",
    };
  }

  // 🔹 Fallback for unknown errors
  return {
    status: 500,
    message:
      "We’re having trouble completing your request right now.. Please try again later.",
  };
}
